import { Directive, OnDestroy } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive()
export abstract class AbstractControlDirective implements OnDestroy, ControlValueAccessor {
  protected subscriptions: Subscription[] = [];

  protected constructor() {}

  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public onBlur(): void {
    this.onTouched();
  }

  public abstract writeValue(value: any): void;
}
